import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, DollarSign, Shield, TrendingUp } from 'lucide-react';
const benefits = [{
  icon: MessageCircle,
  title: 'Protocolo de Conversación Empática',
  description: 'Scripts probados que funcionan en 2024'
}, {
  icon: DollarSign,
  title: 'Pagos en USD a Colombia',
  description: 'Guía completa sin complicaciones'
}, {
  icon: Shield,
  title: 'Sin mostrar tu vida privada',
  description: 'Trabaja detrás de escena, sin exposición'
}, {
  icon: TrendingUp,
  title: 'Habilidad de alto valor',
  description: 'Una inversión que te da libertad de por vida'
}];
export function BenefitsGrid() {
  return <section className="w-full bg-cream-secondary py-16 md:py-24" data-id="element-1">
      <div className="max-w-7xl mx-auto px-6" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-3">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-emerald-primary mb-6" data-id="element-4">
            Lo que obtienes dentro del Máster
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-5">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.article key={index} initial={{
            opacity: 0,
            x: index % 2 === 0 ? -30 : 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="bg-white p-8 rounded-2xl shadow-xl border-2 border-gold-light/30" data-id="element-6">
                <div className="flex items-start gap-6" data-id="element-7">
                  <div className="w-16 h-16 bg-gold-primary rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-8">
                    <Icon className="w-8 h-8 text-emerald-primary" aria-hidden="true" data-id="element-9" />
                  </div>
                  <div data-id="element-10">
                    <h3 className="text-2xl font-bold text-emerald-primary mb-3" data-id="element-11">
                      {benefit.title}
                    </h3>
                    <p className="text-lg text-gray-700" data-id="element-12">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}